import { ChangeEvent, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSpinner } from "@webkit/components/typescript/SpinnerContext";
import { Button } from "react-bootstrap";
import { CForm, CFormInput } from "@coreui/react";
import ReactQuill from "react-quill-new";
import { t } from "i18next";
import { CardTextModel } from "@models/card-text.model";
import cardTextService from "@services/cardText.service";
import { base64ToFile, errorToast, handleDefaultImgClick, successToast } from "@webkit/functions/utils";
import { getToastStore } from "@utils/ToastStore";
import ImageCarousel from "@webkit/components/typescript/DefaultImagesCarousel";

export default function EditCardTextPage() {
    const ctxToast = getToastStore();
    const location = useLocation();
    const [description, setDescription] = useState('');
    const [idCardInfoParent, setidCardInfoParent] = useState('');
    const [idCardText, setIdCardText] = useState('');
    const isDisabled = (!description);
    const { showSpinner, hideSpinner } = useSpinner();
    const navigate = useNavigate();
    // gestione immagine
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const formData = new FormData();
    useEffect(() => {
        recoverData();
    }, []);

    const recoverData = async () => {

        try {

            showSpinner();
            const segments = location.pathname.split('/').filter(Boolean);
            const idCard = segments.at(2) ?? '';
            setIdCardText(idCard);
            const modelCardText = await cardTextService.findCardText(idCard);
            const formattedDescription = modelCardText.textDetail.replace(/\\n/g, '<br/>');

            setidCardInfoParent(modelCardText.parentIdCard);
            setDescription(formattedDescription);
            if (modelCardText.photo) {
                const base64String = modelCardText.photo;
                const dataUrl = `data:image/jpeg;base64,${base64String}`;
                setPreview(dataUrl);

                //converto il base64 in file
                const fileFromBase64 = base64ToFile(dataUrl, 'image_from_backend.jpg');
                //aggiorno anche lo stato selectedFile (utile per eventuale anteprima o debug)
                setSelectedFile(fileFromBase64);
            }
        } catch (error: any) {

            console.error('errore nel recupero dei dati della cardText', error);

        } finally {
            hideSpinner();
        }

    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        const maxSize = 5 * 1024 * 1024;

        if (file) {
            if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
                errorToast(ctxToast, t("error.invalid_image_format"))
                e.target.value = "";
                return;
            }
            if (file.size > maxSize) {
                errorToast(ctxToast, t("error.too_large"))
                e.target.value = "";
                return;
            }
            setSelectedFile(file);

            const previewUrl = URL.createObjectURL(file);
            setPreview(previewUrl);
        }
    };

    const handleSubmit = async () => {
        try {
            showSpinner();

            if (selectedFile) {
                formData.append('img', selectedFile);
            }
            const segments = location.pathname.split('/').filter(Boolean);
            const IdAccomodation = segments.at(1) ?? '';
            const cardTextModel = new CardTextModel(description, idCardInfoParent);
            await cardTextService.updateCardText(idCardText, IdAccomodation, cardTextModel, formData);
            successToast(ctxToast, t("success.updated"))
            navigate(`/new-app/${IdAccomodation}`);
        } catch (error: any) {
            console.error('errore nella chiamata di creazione card Text', error);
        } finally {
            hideSpinner();
        }

    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="card shadow-lg" style={{ width: '70%', borderRadius: '25px' }}>
                <div className="hst-card-header card-header text-uppercase">
                    {t('title.edit_cardtext')}
                </div>
                <div className="card-body">
                    <CForm className="mb-5">
                        <label className="mb-3">{t('label.description')} {t('placeholder.obligatory')}</label>
                        <ReactQuill
                            theme="snow"
                            value={description}
                            onChange={(e) => {
                                if (e == '' || e == '<p><br></p>') {
                                    setDescription('')
                                } else {
                                    setDescription(e);
                                }

                            }}
                            style={{ borderRadius: "15px", height: "300px", marginBottom: "75px" }}
                        />
                        <p className="my-4">{t('text.default_images')} </p>
                        <ImageCarousel 
                        onImageSelect={(base64, index) => 
                        handleDefaultImgClick(base64, index, setSelectedFile, setPreview, formData)
                        }/>
                        <CFormInput
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                        {preview && (
                            <div className="preview-card position-relative">
                                <img
                                    src={preview}
                                    alt={t('label.preview')}
                                    style={{ maxWidth: '200px', height: 'auto' }}
                                />
                                <button
                                    className="hst-close-button-box"
                                    type="button"
                                    onClick={(e) =>{ 
                                        setSelectedFile(null)
                                        setPreview(null)
                                    }}
                                >
                                    ✕
                                </button>
                            </div>
                        )}
                    </CForm>
                    <div
                        className="bg-transparent"
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                        <Button
                            className="hst-btn-secondary mt-4"

                            onClick={() => navigate(-1)}
                        >
                            {t('text.go_back')}
                        </Button>
                        <Button
                            className="hst-btn-primary btn-primary mt-4"
                            onClick={handleSubmit}
                            disabled={isDisabled}
                            style={{fontWeight:"500"}}
                        >
                            {t('button.save')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

};